/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    alternative: { type: 'variant', values: [ true ] },
    inverse: { type: 'variant', values: [ true ] },
    outline: { type: 'variant', values: [ true ] },
    purpose: { type: 'variant', values: [ 'offer', 'editorial', 'subtle' ] },
    size: { type: 'variant', values: [ 'compact' ] }
  },
  rules: [
    {
      if: { inverse: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#ffffff',
        color: '#ffffff'
      }
    },
    {
      if: { alternative: true },
      tokens: {
        backgroundColor: '#eaf3f1',
        borderColor: '#eaf3f1',
        color: '#2b826e'
      }
    },
    {
      if: { outline: true },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', borderColor: '#f9f2dd' }
    },
    {
      if: { purpose: 'offer' },
      tokens: { backgroundColor: '#fce6df', borderColor: '#fce6df' }
    },
    {
      if: { purpose: 'editorial' },
      tokens: { backgroundColor: '#cdcfd5', borderColor: '#cdcfd5' }
    },
    {
      if: { purpose: 'subtle' },
      tokens: { backgroundColor: '#f9f2dd', borderColor: '#f9f2dd' }
    },
    {
      if: { outline: true, purpose: 'subtle' },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', borderColor: '#f9f2dd' }
    },
    {
      if: { outline: true, purpose: 'editorial' },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', borderColor: '#cdcfd5' }
    },
    {
      if: { outline: true, purpose: 'offer' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#fce6df',
        borderWidth: 2,
        color: '#394056'
      }
    },
    {
      if: { size: 'compact' },
      tokens: {
        fontSize: 12,
        paddingBottom: 0,
        paddingLeft: 3,
        paddingRight: 3,
        paddingTop: 0
      }
    }
  ],
  tokens: {
    backgroundColor: '#f9f2dd',
    borderColor: '#f9f2dd',
    borderRadius: 999,
    borderWidth: 2,
    color: '#394056',
    fontName: 'SofiaPro',
    fontSize: 12,
    fontWeight: '400',
    gradient: null,
    paddingBottom: 2,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 2
  }
}
export default theme
